module.exports = __webpack_public_path__ + "media/images/footer-logo-b5689004494dbc1b3103e41e94e06080.png";